import { render, staticRenderFns } from "./LottieIcon.vue?vue&type=template&id=afaa3a2a&scoped=true&"
import script from "./LottieIcon.vue?vue&type=script&lang=js&"
export * from "./LottieIcon.vue?vue&type=script&lang=js&"
import style0 from "./LottieIcon.vue?vue&type=style&index=0&id=afaa3a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaa3a2a",
  null
  
)

export default component.exports